import styled from 'styled-components'

import colors from '@settings/styleSettings'

import Popup from 'reactjs-popup'

export const CharacteristicContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: ${(props) => (props.isSelected ? '0px' : '1px')};

  cursor: pointer;
  width: 100%;
  height: 80px;
  max-height: 80px;

  @media (max-width: 1124px) {
    max-width: 450px;
  }

  @media (max-width: 412px) {
    min-width: 140px;
    gap: 8px;
  }

  background-color: ${colors.white};
  border: ${(props) => (props.isSelected ? '2px' : '1px')} solid
    ${(props) => (props.isSelected ? colors.primary : colors.softGray)};
  border-radius: 12px;
  background: ${(props) => (props.isSelected ? `${colors.primary}08` : 'none')};
`

export const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 3rem;
  height: 3rem;
  margin-left: 12px;

  @media (max-width: 412px) {
    margin-left: 4px;
  }
`

export const CharacteristicInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  width: fit-content;
  height: 40px;

  @media (max-width: 467px) {
    height: 20px;
  }
`

export const CharacteristicTitle = styled.div`
  font-family: 'Circular-Std-Bold';
  font-size: 16px;

  margin: 0;
  color: ${colors.titleStrongBlack};

  @media (max-width: 467px) {
    font-size: 14px;
  }
`

export const BeneficiaryPortion = styled.div`
  font-family: 'Circular-Std';
  font-size: 14px;
  color: ${colors.softGray};

  @media (max-width: 467px) {
    font-size: 11px;
  }
`
export const StyledPopup = styled(Popup)`
  &-content {
    background: ${colors.titleStrongBlack};
    margin: auto;
    padding: 8px 12px 8px 12px;
    border-radius: 10px;
    flex: 1;
    word-wrap: break-word;
    overflow-wrap: break-word;
    background-color: #39C98F;
    color: #fff;
    font-weight: 600;
  }
  &-arrow {
    color: #39C98F;
  }
`
export const PopUpText = styled.div`
  font-family: 'Circular-Std';
  font-size: 14px;
  color: ${colors.background};
`
